export default __webpack_public_path__ + "static/media/nav-calc_pink.d89fe865.svg";